import React, { Component } from 'react'
import { Table, Tooltip, Modal, message, Form, Select, DatePicker, Button, Badge, Avatar } from 'antd'
import { connect } from 'dva'
import { Link } from 'dva/router'
import moment from 'moment'
import InfiniteScroll from '@fand/react-infinite-scroll-container';
import Currency from 'react-currency-formatter';
import { all } from '../../services/restApi'
import { getTotal, createPassword } from '../../utils'
import config from '../../utils/config'
import ActivityNew from './activityNew'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const confirm = Modal.confirm
const FormItem = Form.Item;
const Option = Select.Option;
const MonthPicker = DatePicker.MonthPicker;
const ButtonGroup = Button.Group;

class Activity extends Component {

    constructor (props) {
        super(props);

        this.state = {
            query: {},
            companies: [],
            activities: [],
            NewActivityVisible: false,
            NewActivityProps: {},
            skip: 0,
            limit: 1000
        }

        message.config({top: 110, duration: 4});

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId)  {
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
        } else {
            if (this.props.location.pathname === '/activities/payments/hotel')
                window.history.back()
        }

        /*if (localStorage.getItem('hotelConta')) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('hotelConta'))};*/
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        // Consulta los hoteles
        all('TourCompany', {limit: 20}).then((resp) => {
            this.setState({
                companies: resp.results
            });
        })
    }


    /**
    * Se llama antes del render()
    */
    componentWillMount () {
        this.props.dispatch({type:'activity/filterSuccess', 
            payload: { activities: [] }
        });

        this.firstLoad();
    }



    /**
    * Agrupamos: Cada registro por fecha de creación
    */
    groupByDate (array, count) {

        let activitiesGrouped = _.groupBy(array, function (d) { return moment(d.createdAt.iso).format('YYYY-MM-DD') });
        let activitiesOwner = _.filter(array, { chargedTo: 'propietario' });
        let activitiesTrie = _.filter(array, { chargedTo: 'trie' });

        Object.keys(activitiesGrouped).map((key, index) => {

            let item = {};
            item.createdAt = {__type: 'Date', iso: key};
            item.isParent =  true;
            item.children =  activitiesGrouped[key];
            item.objectId = createPassword();
            item.amount_activity_total = getTotal(activitiesGrouped[key], 'amount_activity');
            item.amount_expense_total = getTotal(activitiesGrouped[key], 'amount_expense');
            item.children.map((i) => { i.parentId = item.objectId });

            this.state.activities.push(item);

            if (index === Object.keys(activitiesGrouped).length - 1) {
                let total = getTotal(this.state.activities, 'amount_activity_total') - getTotal(this.state.activities, 'amount_expense_total')
                let totalOwner = getTotal(activitiesOwner, 'amount_activity') - getTotal(activitiesOwner, 'amount_expense');
                let totalTrie = getTotal(activitiesTrie, 'amount_activity') - getTotal(activitiesTrie, 'amount_expense');

                this.setState({ currentTotal: total, totalOwner: totalOwner, totalTrie: totalTrie });

                setTimeout(function() {
                    this.props.dispatch({type: 'app/hideLoadingTable'})
                    this.props.dispatch({type:'activity/querySuccess', 
                        payload: { activities: this.state.activities }
                    });
                }.bind(this), 500);
            }
        });
    }


    setTotals (array) {
        let activitiesOwner = _.filter(array, { chargedTo: 'propietario' });
        let activitiesTrie = _.filter(array, { chargedTo: 'trie' });

        let total = getTotal(array, 'amount_activity') - getTotal(array, 'amount_expense')
        let totalOwner = getTotal(activitiesOwner, 'amount_activity') - getTotal(activitiesOwner, 'amount_expense');
        let totalTrie = getTotal(activitiesTrie, 'amount_activity') - getTotal(activitiesTrie, 'amount_expense');

        this.setState({ currentTotal: total, totalOwner: totalOwner, totalTrie: totalTrie });
    }


    /**
    * Primera carga
    */
    firstLoad () {
        this.props.dispatch({ type: 'app/showLoadingTable' })

        let query = {};

        all('Activity', {
            where: query,
            include: 'createdBy,category,category.companies',
            skip: 0, 
            limit: this.props.activity.limit,
            count: 1, 
            order: '-createdAt'
        }).then(resp => {

            if (resp.results.length > 0) {
                /*const activities = [];
                resp.results.map((item, key) => {

                    return all('Activity', {
                        where: {
                            parent_category: {__type: 'Pointer', className: 'Activity', objectId: item.objectId}
                        },
                        include: 'parent_category,createdBy,hotels'
                    }).then(activity => {
                        if (activity.results.length > 0)
                            item.children = activity.results;

                        activities.push(item);

                        if (key === resp.results.length - 1) {
                            setTimeout(function() {
                                this.props.dispatch({ type: 'app/hideLoadingTable' })
                                this.props.dispatch({type: 'activity/queryFirst', payload: {
                                    activities: activities, 
                                    skip: 0, 
                                    limit: this.props.activity.limit,
                                    total_items: resp.count,
                                }})
                            }.bind(this), 100);
                        }
                    });
                });*/

                this.props.dispatch({ type: 'app/hideLoadingTable' })
                this.props.dispatch({type: 'activity/queryFirst', payload: {
                    activities: resp.results, 
                    skip: 0, 
                    limit: this.props.activity.limit,
                    total_items: resp.count,
                }})

            } else {
                this.props.dispatch({ type: 'app/hideLoadingTable' })
            }
        });
    }


    /**
    * Carga otro bloque de registros
    */
    loadMore () {
        if (this.state.skip < this.state.total_items) {

            this.props.dispatch({type: 'app/showLoadingTable'})
            this.setState({ skip: this.state.skip + this.state.limit });

            all('Activity', {
                where: this.state.query,
                include: 'createdBy,category,category.companies',
                skip: this.props.activity.skip, 
                limit: this.props.activity.limit, 
                count: 1, 
                order: 'createdAt'
            }).then(resp => {

                this.props.dispatch({type: 'app/hideLoadingTable'})

                if (resp.results.length > 0) {
                    let array = this.state.activities;
                    
                    this.setState({ activities: array.concat(resp.results) });

                    this.props.dispatch({type:'activity/querySuccess', 
                        payload: { activities: this.state.activities }
                    });
                }

            }).catch(e => {
                if (e && e.data) message.error(e.data.error);
                else message.error('Ha ocurrido un error al consultar otros registros. Intente más tarde')    
            });
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetch (value, callback) {
        setTimeout(() => {
            all('TourCompany', {where: {name: {$regex: '(?i)' + value}}}).then((d) => {
                const results = d.results;
                const companies = [];
                
                results.forEach((r) => {
                    companies.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(companies);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ companies: resp })
            });
        }
    }


    /**
    * Búsqueda
    */
    search (notReload) {
        this.props.dispatch({type: 'app/showLoadingTable'})

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Query
            let query;
            notReload ? query = this.state.query : query = {type: 'payments'};

            if (this.state.currentHotel) {
                query.hotel = {__type: 'Pointer', className: 'TourCompany', objectId: this.state.currentHotel.objectId};
            }

            if (values.custom_date) {
                query.createdAt ={
                    $gte: {__type: 'Date', iso: new Date(moment(values.custom_date).startOf('month').format()).toISOString()},
                    $lte: {__type: 'Date', iso: new Date(moment(values.custom_date).endOf('month').format()).toISOString()},
                }

            } else {
                query.createdAt = {
                    $gte: {__type: 'Date', iso: new Date(moment().startOf('month').format()).toISOString()},
                    $lte: {__type: 'Date', iso: new Date(moment().endOf('month').format()).toISOString()},
                };
            }


            this.setState({query: query});

            all('Activity', {
                where: query,
                include: 'hotel,payment,createdBy', 
                skip: 0, 
                limit: this.state.limit, 
                count: 1, 
                order: 'createdAt'
            }).then(resp => {
                
                this.props.dispatch({type: 'app/hideLoadingTable'})
                this.setState({activities: [], skip: this.state.limit, total_items: resp.count});

                this.getPreviousTotal();
                this.props.dispatch({type:'activity/filterSuccess', 
                    payload: { activities: [] }
                });

                /*if (resp.results.length > 0)
                    this.groupByDate(resp.results, resp.count);
                else
                    this.props.dispatch({type: 'app/hideLoadingTable'})*/

                if (resp.results.length > 0) {

                    this.setTotals(resp.results);
                    this.setState({ activities: resp.results });

                    this.props.dispatch({type:'activity/querySuccess', 
                        payload: { activities: this.state.activities }
                    });
                } else {
                    this.setState({ totalOwner: 0, totalTrie: 0 });
                }

            }).catch(e => {
                if (e && e.data) message.error(e.data.error);
                else message.error('Ha ocurrido un error. Intente más tarde')    
            });
        })
    }


    /**
    * Elimina un registro
    */
    delete_item (item) {
        
        let dispatch = this.props.dispatch;
        let currentTotal = this.state.currentTotal;
        let currentState = this;

        confirm({
            title: '¿Estás seguro que deseas eliminar el registro?',
            onOk () {
                dispatch({type: 'activity/removeItem', payload: item});

                setTimeout(function() {
                    currentState.setTotals(currentState.props.activity.activities);
                }, 1000);
            }
        })
    }


    /**
    * Establece el acción para editar
    */
    setUpdate (item) {
        this.setState({ 
            NewActivityProps: {
                activityId: item.objectId
            }
        });
        this.showModalNewActivity();
    }


    /**
    * Establece el acción para crear
    */
    setCreate (item) {
        this.setState({ NewActivityProps: {} });
        this.showModalNewActivity();
    }


    /**
    * Actualiza el registro como gasto pagado
    */
    activityPaidout (item) {

        // Model
        let data = {};
        data.objectId = item.objectId;
        data.type = 'payments';
        data.status = 'paidout';
        data.parentId = item.parentId;

        this.props.dispatch({type: 'activity/update', payload: data});
    }


    /**
    * Muestra / Oculta el modal para nuevo ingreso
    */
    showModalNewActivity () { this.setState({ NewActivityVisible: true }); }
    hideModalNewActivity () { 
        //this.props.form.resetFields();
        //this.setState({ NewActivityVisible: false, activities: [] }); 
        this.setState({ NewActivityVisible: false }); 
        /*this.props.dispatch({type:'activity/filterSuccess', 
            payload: {
                activities: [], 
                skip: this.state.limit, 
                total_items: 0
            }
        });*/
        this.firstLoad(); 
    }


    /**
    * Render del componente
    */
    render () {
        const hotel_options = this.state.companies.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        <Link onClick={() => window.history.back() }><i className="fa fa-arrow-circle-left"></i></Link>
                        Actividades&nbsp;
                        <Button type='primary' className="pull-right">
                            <Link onClick={this.setCreate.bind(this)} className=""><Icon name="plus" /> Agregar nueva actividad</Link>
                        </Button>
                    </h1>
                </section>

                <section className="content">
                    <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                        <div className="box-body">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="table-responsive table">

                                        <InfiniteScroll
                                            padding={50}
                                            throttle={100}
                                            onScroll={() => this.loadMore()}>

                                            <Table 
                                                dataSource={this.props.activity.activities} 
                                                rowKey="objectId" 
                                                size="middle" 
                                                loading={this.props.app.loadingTable} 
                                                pagination={false}>
                                                
                                                <Column key="picture" render={(item) => (
                                                    <span>
                                                        {!item.category.picture ?
                                                            <Avatar size="large" src="assets/img/noimage.png" /> :
                                                            <Avatar size="large" src={config.externalUrl + 'uploads/activities/' + item.category.picture} style={{borderColor: item.color, borderWidth: '2px'}} />
                                                        }
                                                    </span>
                                                )} />
                                                <Column title="Nombre" dataIndex="name" key="name" />
                                                <Column title="Precio" key="price" render={(item) => (
                                                    <span>
                                                        {item.price
                                                            ? <Currency quantity={item.price} currency="USD" />
                                                            : '-'
                                                        }
                                                    </span>
                                                )}/>
                                                <Column width={350} title="Descripción" key="description" render={(item) => (
                                                    <small>{item.description}</small>
                                                )} />
                                                <Column title="Categoría" key="category" render={(item) => (
                                                    <span>{item.category ? item.category.name : '-'}</span>
                                                )} />
                                                <Column title="Empresas" key="companies" render={(item) => (
                                                    <span>
                                                        {item.category.companies && item.category.companies.map(d => <span key={d.objectId}>{d.name},<br /></span>)}
                                                    </span>
                                                )} />
                                                <Column title="Creado por" key="createdBy" render={(item) => (
                                                    <span>{item.createdBy ? item.createdBy.name : '-'}</span>
                                                )} />
                                                <Column title="Status" key="active" render={(item) => (
                                                    <span>
                                                        {item.active
                                                            ? <span><Badge status="success" /><small>Activo</small></span>
                                                            : <span><Badge status="warning" /><small>Inactivo</small></span>
                                                        }
                                                    </span>
                                                )}/>
                                                <Column width={90} title="Acciones" key="action"
                                                    render={(item) => (
                                                        <span className="actions">
                                                            <ButtonGroup>
                                                                <Tooltip placement="bottom" title="Editar">
                                                                    <Button>
                                                                        <Link onClick={() => { this.setUpdate(item) }}><Icon name="edit" /></Link>
                                                                    </Button>
                                                                </Tooltip>

                                                                {(item.children && item.children.length === 0) || !item.children
                                                                    ?<Tooltip placement="bottom" title="Eliminar">
                                                                        <Button>
                                                                            <Link onClick={() => { this.delete_item(item) }} className=""><Icon name="trash" /></Link>
                                                                        </Button>
                                                                    </Tooltip>
                                                                    : ''
                                                                }
                                                            </ButtonGroup>
                                                        </span>
                                                    )}
                                                />
                                            </Table>              
                                        </InfiniteScroll>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <Modal
                    width={700}
                    visible={this.state.NewActivityVisible}
                    title="Nueva actividad"
                    onCancel={this.hideModalNewActivity.bind(this)}
                    footer={[]} 
                >
                    {this.state.NewActivityVisible
                        ? <ActivityNew {...this.state.NewActivityProps} />
                        : ''
                    }
                </Modal>
            </div>
        )
    }
}

export default connect(({activity, app}) => ({activity, app}))(Form.create()(Activity))


// WEBPACK FOOTER //
// ./src/components/activities/index.js